import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
  color: var(--p-text-color);
}

p-checkbox {
  --p-input-margin-bottom: 0;
}

.error-message {
  color: var(--p-error);
  font-size: var(--p-error-font-size, .875rem);
  line-height: var(--p-error-line-height, 1.3);
  margin-bottom: 15px;
}

.info-message {
  background: #EAF2F7;
  padding: 1em 0.75em;
  border: 1px solid rgba(48, 124, 171, .3);
  font-size: 0.875rem;
  border-radius: 5px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 0.5em;
}

.info-message svg {
  color: #307CAB;
}

/**
--------------------------------------------------
* Success message
--------------------------------------------------
*/
.success {
  padding: 20px;
  text-align: center;
  color: var(--p-text-color);
}

.success h2 {
  font-family: var(--p-h4-font);
  font-size: var(--p-h4-font-size);
  font-weight: var(--p-h4-font-weight);
  font-style: var(--p-h4-font-style);
  line-height: var(--p-h4-line-height);
  text-transform: var(--p-h4-transform);
  letter-spacing: var(--p-h4-letter-spacing);
  margin: 0 0 var(--p-h4-margin-bottom);
  color: var(--p-text-color);
}


.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: var(--p-success);
  fill: none;
  animation: stroke .6s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;
}

.checkmark-svg {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: white;
  stroke-miterlimit: 10;
  margin: 1.5em auto;
  box-shadow: inset 0px 0px 0px var(--p-success);
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke .3s cubic-bezier(0.650, 0.000, 0.450, 1.000) .8s forwards;
}

@keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes scale {
    0%, 100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }

  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 50px var(--p-success);
    }
  }
`;
